import "core-js/modules/es6.regexp.to-string";
import _classCallCheck from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import CryptoJS from 'crypto-js';

var crypto = /*#__PURE__*/function () {
  function crypto() {
    _classCallCheck(this, crypto);
  }

  _createClass(crypto, null, [{
    key: "encrypt",
    value: // 使用AesUtil.genAesKey()生成,需和后端配置保持一致
    // 使用DesUtil.genDesKey()生成,需和后端配置保持一致

    /**
     * aes 加密方法
     * @param data
     * @returns {*}
     */
    function encrypt(data) {
      return this.encryptAES(data, this.aesKey);
    }
    /**
     * aes 解密方法
     * @param data
     * @returns {*}
     */

  }, {
    key: "decrypt",
    value: function decrypt(data) {
      return this.decryptAES(data, this.aesKey);
    }
    /**
     * aes 加密方法，同java：AesUtil.encryptToBase64(text, aesKey);
     */

  }, {
    key: "encryptAES",
    value: function encryptAES(data, key) {
      var dataBytes = CryptoJS.enc.Utf8.parse(data);
      var keyBytes = CryptoJS.enc.Utf8.parse(key);
      var encrypted = CryptoJS.AES.encrypt(dataBytes, keyBytes, {
        iv: keyBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    }
    /**
     * aes 解密方法，同java：AesUtil.decryptFormBase64ToString(encrypt, aesKey);
     */

  }, {
    key: "decryptAES",
    value: function decryptAES(data, key) {
      var keyBytes = CryptoJS.enc.Utf8.parse(key);
      var decrypted = CryptoJS.AES.decrypt(data, keyBytes, {
        iv: keyBytes,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return CryptoJS.enc.Utf8.stringify(decrypted);
    }
    /**
     * des 加密方法，同java：DesUtil.encryptToBase64(text, desKey)
     */

  }, {
    key: "encryptDES",
    value: function encryptDES(data, key) {
      var keyHex = CryptoJS.enc.Utf8.parse(key);
      var encrypted = CryptoJS.DES.encrypt(data, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    }
    /**
     * des 解密方法，同java：DesUtil.decryptFormBase64(encryptBase64, desKey);
     */

  }, {
    key: "decryptDES",
    value: function decryptDES(data, key) {
      var keyHex = CryptoJS.enc.Utf8.parse(key);
      var decrypted = CryptoJS.DES.decrypt({
        ciphertext: CryptoJS.enc.Base64.parse(data)
      }, keyHex, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    }
  }]);

  return crypto;
}();

_defineProperty(crypto, "aesKey", "O2BEeIv399qHQNhD6aGW8R8DEj4bqHXm");

_defineProperty(crypto, "desKey", "jMVCBsFGDQr1USHo");

export { crypto as default };